import React from 'react';
import { useAdInitialization } from './hooks/useAdInitialization';

interface AdUnitProps {
  slot: string;
  width: number;
  height: number;
  format?: 'auto' | 'fluid' | 'rectangle';
  layout?: 'in-article' | 'in-feed';
  className?: string;
}

export default function AdUnit({
  slot,
  width,
  height,
  format = 'auto',
  layout,
  className = ''
}: AdUnitProps) {
  const { adRef } = useAdInitialization();

  return (
    <div
      ref={adRef}
      className={`ad-container relative ${className}`}
      style={{
        width: format === 'rectangle' ? `${width}px` : '100%',
        height: format === 'rectangle' ? `${height}px` : 'auto',
        minWidth: `${width}px`,
        minHeight: `${height}px`,
        display: 'block', // Ensure the container is visible
        overflow: 'hidden'
      }}
    >
      <ins
        className="adsbygoogle"
        style={{
          display: 'block',
          width: '100%',
          height: '100%'
        }}
        data-ad-client="ca-pub-4637961908114415"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={format !== 'rectangle'}
        {...(layout && { 'data-ad-layout': layout })}
      />
    </div>
  );
}